import { useEffect, useState } from "react";

import { FolderFileDocumentCode } from "src/core/constants/folder";
import { FolderFileQuery } from "src/core/gql/graphql";
import { DocumentField } from "src/core/utils/documents";

export const useRequiredDocuments = (
  folderFile: FolderFileQuery | undefined,
  stakeholderId: string | undefined
): DocumentField[] => {
  const [requiredDocuments, setRequiredDocuments] = useState<DocumentField[]>([]);

  useEffect(() => {
    if (!folderFile || !stakeholderId) return;

    const documents =
      folderFile.folderFile?.fileCustomerFolder?.stakeholders
        ?.find((stakeholder: { entity: { id: string } }) => stakeholder.entity.id === stakeholderId)
        ?.supportingDocuments?.map((doc) => ({
          code: doc.abstractDocumentType?.code ?? "",
          label: doc.abstractDocumentType?.name ?? "",
        }))
        .filter((doc) => doc.code !== FolderFileDocumentCode.MISSION_LETTER)
        .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

    setRequiredDocuments(documents);
  }, [folderFile, stakeholderId]);

  return requiredDocuments;
};
